import axios from "axios";

export const state = {
    birthcertificates: [],
};

export const getters = {
    birthcertificates: state => state.birthcertificates,
};

export const mutations = {
    setCertificates(state, newValue) {
        state.birthcertificates = newValue
    },
};

export const actions = {
    fetchBirthCertificates({ commit }) {
        return axios.get('/birthcertificates').then(res => {
            commit('setCertificates', res.data.certificates)
        })
    },
};
